export default "__VITE_ASSET__DFehYhXZ__"